import { Action } from '@ngrx/store';
import { AbstractControl } from '@angular/forms';

import { RuleListModel } from '../../models/RuleListModel';
import { IAutoSave } from '../../../pillar/workspace/IAutoSave';
import { RuleParameterModel } from '../../models/RuleParameterModel';

export const UPDATE_RULE_PARAMETER_SUCCESS = '[Rule] Update Rule Parameter Success';

export class UpdateRuleParameterSuccessAction implements Action {
  readonly type = UPDATE_RULE_PARAMETER_SUCCESS;

  constructor(public payload: {
                rule: RuleListModel,
                parameter: RuleParameterModel,
                control: IAutoSave & AbstractControl
              }) {}
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/actions/UpdateRuleParameterSuccessAction.ts